import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { Box, Stack, Typography } from '@mui/material';

import { routePaths } from 'src/services/routing/routePaths';
import PasswordResetConfirmForm from 'src/components/account/PasswordResetConfirmPage/components/PasswordResetConfirmFormContainer';

export const PASSWORD_RESET_CONFIRM_PAGE_TEST_ID =
  'password-reset-confirm-page';

const PasswordResetConfirmContent: FC = () => {
  const history = useHistory();
  const params: { token?: string; uid?: string } = useParams();
  const { t } = useTranslation(['login']);

  const handleDone = () => {
    history.push(routePaths.SURVEY_LIST);
  };

  return (
    <Box data-test-id={PASSWORD_RESET_CONFIRM_PAGE_TEST_ID}>
      <Typography variant="h1" sx={{ mb: 5, textAlign: 'center' }}>
        {t('resetPassword')}
      </Typography>
      <Box>
        <Stack direction="row" sx={{ justifyContent: 'center', mb: 2 }}>
          <Typography>{t('passwordResetHeader')}</Typography>
        </Stack>

        <PasswordResetConfirmForm
          onDone={handleDone}
          token={params.token}
          uid={params.uid}
        />
      </Box>
    </Box>
  );
};

export default PasswordResetConfirmContent;
